import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import type { AuditDynamicFormErrorDialogProps } from '../../types/auditFormTypes';

const AuditDynamicFormErrorDialog: React.FC<AuditDynamicFormErrorDialogProps> = React.memo(({
  open,
  errorMessage,
  onClose,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: '#EEE8FF',
        color: '#222B45',
        fontWeight: 'bold',
        mb: 0,
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '20px' }}>
        Form Validation Errors
      </Typography>
      <Button onClick={onClose} sx={{ minWidth: 'auto', color: '#222B45' }}>
        <Close />
      </Button>
    </DialogTitle>

    <DialogContent dividers sx={{ p: 3 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.5 }}>
          Please fix the highlighted fields.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          These issues must be resolved before saving.
        </Typography>
      </Box>

      <Typography variant="body2" sx={{ whiteSpace: 'pre-line', color: '#222B45' }}>
        {errorMessage}
      </Typography>
    </DialogContent>

    <DialogActions sx={{ p: 2 }}>
      <Button
        onClick={onClose}
        variant="outlined"
        sx={{ color: '#2C6CA0', borderColor: '#2C6CA0', fontWeight: 600, fontSize: '15px' }}
      >
        Close
      </Button>
    </DialogActions>
  </Dialog>
));

AuditDynamicFormErrorDialog.displayName = 'AuditDynamicFormErrorDialog';

export default AuditDynamicFormErrorDialog;
